import {JsonProperty} from '../shared/decorators/json-property';
import { Constants } from '../shared/utils/constants';

export class KYCModel {
  @JsonProperty('user_id')
  id: number;
  email: string;
  @JsonProperty('kyc_status')
  status: number;
  @JsonProperty('id_status')
  idStatus: number;
  @JsonProperty('image_kyc_id_url')
  idUrl: string;
  @JsonProperty('image_kyc_id_back_url')
  idBackUrl: string;
  @JsonProperty('selfie_status')
  handStatus: number;
  @JsonProperty('image_kyc_selfie_url')
  handUrl: string;
  @JsonProperty('address_status')
  addressStatus: number;
  @JsonProperty('image_kyc_address_url')
  addressUrl: string;
  @JsonProperty('image_kyc_address_back_url')
  addressBackUrl: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('phone_number')
  phone: string;
  @JsonProperty('date_of_birth')
  dob: string;
  @JsonProperty('city_town')
  city: string;
  @JsonProperty('street_number')
  street: string;
  @JsonProperty('residential_address')
  address: string;
  @JsonProperty('postal_zipcode')
  zipCode: string;
  country: string;
  @JsonProperty('first_name_jp')
  firstNameJP: string;
  @JsonProperty('last_name_jp')
  lastNameJP: string;
  @JsonProperty('kyc_comment')
  comment: string;
  @JsonProperty('building')
  building: string;

  constructor() {
    this.id = undefined;
    this.email = undefined;
    this.idStatus = undefined;
    this.idUrl = undefined;
    this.idBackUrl = undefined;
    this.handStatus = undefined;
    this.handUrl = undefined;
    this.addressStatus = undefined;
    this.addressUrl = undefined;
    this.addressBackUrl = undefined;
    this.lastName = undefined;
    this.middleName = undefined;
    this.firstName = undefined;
    this.status = undefined;
    this.phone = undefined;
    this.dob = undefined;
    this.city = undefined;
    this.street = undefined;
    this.address = undefined;
    this.country = undefined;
    this.zipCode = undefined;
    this.firstNameJP = undefined;
    this.lastNameJP = undefined;
    this.comment = undefined;
    this.building=undefined;
  }
  getUsername(): string {
    return this.firstName + ' ' + this.lastName;
  }
  getUsernameJP(): string {
    return this.firstNameJP ? this.firstNameJP : ' '
      + ' ' + this.lastNameJP ? this.lastNameJP : '';
  }
  getStatusKyc(): string {
    switch (this.status) {
      case -1:
        return '<span class="text-muted">Unuploaded</span>';
      case 0:
        return '<span class="text-primary">Uploaded</span>';
      case 1:
        return '<span class="text-green">Verified</span>';
      case 2:
        return '<span class="text-red">Rejected</span>';
    }
  }
}

export class CreditCardModel {
  @JsonProperty('credit_card_id')
  id: number;
  @JsonProperty('user_id')
  userId: number;
  status: number;
  email: string;
  name: string;
  @JsonProperty('number')
  cardNumber: string;
  expiration: string;
  @JsonProperty('card_status')
  cardStatus: number;
  @JsonProperty('card_on_hand_status')
  cardHandStatus: string;
  @JsonProperty('image_card_url')
  cardUrl: string;
  @JsonProperty('image_card_on_hand_url')
  cardHandUrl: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('last_name')
  lastName: string;


  constructor() {
    this.id = undefined;
    this.userId = undefined;
    this.email = undefined;
    this.name = undefined;
    this.cardNumber = undefined;
    this.expiration = undefined;
    this.cardStatus = undefined;
    this.cardHandStatus = undefined;
    this.cardUrl = undefined;
    this.cardHandUrl = undefined;
    this.status = undefined;
    this.firstName = undefined;
    this.lastName = undefined;
  }

  getUsername(): string {
    return (this.firstName ? this.firstName : '')
     + ' ' + (this.lastName ? this.lastName : '');
  }

  maskSomeDigit(): string {
    const validCardNumber = this.cardNumber.replace(/ /g, '');
    const listNumber = [...validCardNumber];
    const length = listNumber.length;
    if (length > 0 && length <= 16) {
      let value = '';
      for (let i = 0; i < length + 1; i++) {
        if (listNumber[i] === undefined) {
          break;
        }
        value += listNumber[i];
        if ((i + 1) % 4 === 0) {
          value += ' ';
        }
      }
      return value;
    }
  }

  getStatusCard(): string {
    switch (this.status) {
      case -1: {
        return 'unUpload';
      }
      case 0: {
        return 'Pending';
      }
      case 1: {
        return 'Approval';
      }
      case 2: {
        return 'Rejected';
      }
    }
  }
}

export class AddressModel {
  @JsonProperty('user_id')
  id: number;
  email: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('first_name_jp')
  firstNameJP: string;
  @JsonProperty('last_name_jp')
  lastNameJP: string;
  @JsonProperty('phone_number')
  phone: string;
  @JsonProperty('date_of_birth')
  dob: string;
  @JsonProperty('city_town')
  city: string;
  @JsonProperty('street_number')
  street: string;
  @JsonProperty('residential_address')
  address: string;
  @JsonProperty('postal_zipcode')
  zipCode: string;
  country: string;
  @JsonProperty('building')
  building: string;
  @JsonProperty('sex')
  gender: number;
  constructor() {
    this.id = undefined;
    this.email = undefined;
    this.lastName = undefined;
    this.middleName = undefined;
    this.firstName = undefined;
    this.firstNameJP = undefined;
    this.lastNameJP = undefined;
    this.phone = undefined;
    this.dob = undefined;
    this.city = undefined;
    this.street = undefined;
    this.address = undefined;
    this.country = undefined;
    this.zipCode = undefined;
    this.gender = undefined;
    this.building = undefined
  }
  getUsername(): string {
    return this.firstName
      ? this.firstName
      : '' + ' ' + this.lastName
      ? this.lastName
      : '';
  }

  getFullName():string {
    return `${this.firstName || ''} ${this.middleName || ''} ${this.lastName || ''}`.trim()
  }

  fullNameJP():string {
    if(this.country === 'JP'){
      return `${this.firstNameJP || ''} ${this.lastNameJP || ''}`.trim()
    }
    return null
  }
}
export class DealsModel{
  @JsonProperty('order_id')
  order_id:number;
  @JsonProperty('open_time')
  open_time:string;
  @JsonProperty('close_time')
  close_time:string;
  @JsonProperty('credit_used')
  credit_used:string;
  @JsonProperty('pnl_by_credit')
  pnl_by_credit:string;
  constructor() {
    this.order_id = undefined;
    this.open_time = undefined;
    this.close_time = undefined;
    this.credit_used = undefined;
    this.pnl_by_credit = undefined;
  }
}

